// extracted by css-extract-rspack-plugin
export default {"item":"item-LcUo6t","message":"message-sfeEMr","close":"close-pafXFI"};